<template>
  <div>
    <div class="bj">
      <div class="content">
        <div class="headBox">
          <div class="name">添加公司成员</div>
          <div class="iconfont icon-close close" @click="quxiaoClick"></div>
        </div>
        <div class="inpCpnt">
          <div class="name">号码搜索:</div>
          <div class="inpBox">
            <div
              class="iconfont icon-search search dis-cent"
              @click="quxiaoClick"
            ></div>
            <div class="inp">
              <input
                type="text"
                placeholder="请输入电话号码搜索"
                v-model="searChTxt"
                @keyup.enter="searchClick"
              />
              <div class="btn" @click="searchClick">搜索</div>
            </div>
          </div>
        </div>
        <div class="cont">
          <Kong v-if="list.length == 0" />
          <div
            class="box"
            :class="item.id == listOn ? 'on' : ''"
            v-for="item in list"
            @click="listClick(item.id)"
          >
            <div class="img">
              <div
                class="iconfont icon-right right"
                v-if="item.id == listOn"
              ></div>
              <img :src="$imgUrl + item.avatars" alt="" />
            </div>
            <div class="name dis-cent">{{ item.realname }}</div>
          </div>
        </div>
        <div class="btnsBox">
          <div class="btn huisebeij" @click="quxiaoClick">取消</div>
          <div class="btn" @click="saveClick">确定</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Kong from "./kong.vue";

export default {
  components: {
    Kong,
  },
  name: "",
  data() {
    return {
      judge: true,
      page: {
        pageNo: 1,
        pageSize: 30,
      },
      listOn: 0,
      list: [],
      searChTxt: "",
    };
  },
  created() {
    // this.listGet();
  },
  methods: {
    listClick(id) {
      this.listOn = id;
    },
    searchClick() {
      if (!this.searChTxt) {
        this.$message.error("手机号码不能为空");
        return;
      }
      this.page.mobile = this.searChTxt;
      this.page.pageNo = 1;
      this.totalCount = 0;
      this.listGet();
    },
    listGet() {
      if (!this.judge) {
        return;
      }
      this.judge = false;
      this.$get("/nozzle/web/member_search", this.page).then((res) => {
        console.log(res);
        this.judge = true;
        if (this.totalCount == 0) {
          this.totalCount = res.totalCount;
        }
        if (res.data) {
          this.list = res.data;
        } else {
          this.list = [];
        }
      });
    },
    quxiaoClick() {
      this.$emit("show");
    },
    saveClick() {
      this.$post("/nozzle/web/company_holding", {
        member_id: this.listOn,
      }).then((res) => {
        if (res.data.status == 1) {
          this.$message.success("提交成功");
          this.$emit("show", { type: true });
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
  },
  mounted() {},
  computed: {},
};
</script>
<style lang="less" scoped>
.bj {
  display: flex;
  align-items: center;
  justify-content: center;
}
.content {
  width: 600px;
  height: 500px;
  border-radius: 5px;
  background-color: #fff;
  .headBox {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 50px;
    padding: 0 15px;
    .name {
      font-weight: 600;
      font-size: 18px;
    }
    .close {
      color: #9c9c9c;
      font-size: 18px;
      cursor: pointer;
    }
  }
  .inpCpnt {
    padding: 0 15px;
    display: flex;
    align-items: center;
    .name {
      width: 70px;
    }
    .inpBox {
      width: calc(100% - 70px);
      height: 35px;
      border-radius: 5px;
      border: 1px solid #dfdfdf;
      box-sizing: border-box;
      display: flex;
      overflow: hidden;
      .search {
        width: 35px;
        height: 35px;
        font-size: 18px;
        color: #9c9c9c;
      }
      .inp {
        width: calc(100% - 35px);
        height: 100%;
        position: relative;
        input {
          width: 100%;
          height: 100%;
        }
        .btn {
          position: absolute;
          top: 0;
          right: 0;
          width: 60px;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 12px;
          background-color: #1290f7;
          color: #fff;
          cursor: pointer;
        }
      }
    }
  }
  .cont {
    overflow: auto;
    padding: 0 15px;
    height: calc(100% - 150px);
    margin-top: 15px;
    cursor: pointer;
    .box {
      width: calc(16.66% - 12.5px);
      margin-right: 15px;
      margin-bottom: 15px;
      float: left;
      border-radius: 5px;
      overflow: hidden;
      .img {
        width: 100%;
        padding-top: 100%;
        border-radius: 5px;
        position: relative;
        background-color: #fff;
        border-radius: 0;
        .right {
          position: absolute;
          top: 0;
          right: 0;
          width: 19px;
          height: 19px;
          background-color: rgba(0, 0, 0, 0.4);
          z-index: 9;
          border-bottom-left-radius: 5px;
          font-size: 14px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        img {
          position: absolute;
          top: 0;
          left: 0;
        }
      }
      .name {
        text-align: center;
      }
    }
    .on {
      background-color: #1290f7;
      color: #fff;
    }
    .box:nth-child(6n) {
      margin-right: 0;
    }
  }
  .btnsBox {
    height: 50px;
    border-top: 1px solid #ebebeb;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 0 15px;
    .btn {
      width: 60px;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 15px;
      background-color: #1290f7;
      color: #fff;
      border-radius: 5px;
      cursor: pointer;
    }
    .huisebeij {
      background-color: #b1b1b1;
    }
  }
}
</style>
